import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

export default class MwSwitch extends Component {
  @tracked everyoneCanInvite1 = true;
  @tracked everyoneCanInvite2 = false;
  @tracked everyoneCanInvite3 = false;
  @tracked everyoneCanInvite4 = true;
  @tracked everyoneCanInvite5 = false;
  @tracked everyoneCanInvite6 = true;
  @tracked everyoneCanInvite7 = false;
  @tracked everyoneCanInvite8 = false;
  @tracked everyoneCanInvite9 = false;
  @tracked everyoneCanInvite10 = false;
  @tracked everyoneCanInvite11 = true;
  @tracked everyoneCanInvite12 = false;
  @tracked everyoneCanInvite13 = false;
  @tracked everyoneCanInvite14 = false;
  @tracked everyoneCanInvite15 = false;
}
